// src/components/common/constants/exportColumns.ts
import { ExportColumn } from "../ExportData/ExportData";
import { Product } from "../../Products/types/products";
import { stringFormatter } from "@kivunova/kivufrontendcommon";
import { Category } from "../../Category/types/categoryTypes";

export const exportProductColumns: ExportColumn<Product>[] = [
  {
    key: "name",
    label: "Product Name"
  },
  {
    key: "brandName",
    label: "Brand"
  },
  {
    key: "supplierId",
    label: "Supplier ID",
    formatter: (value) => value ?? "N/A"
  },
  {
    key: "productCategory",
    label: "Category",
    formatter: (value) => value ?? "N/A"
  },
  {
    key: "sellingMode",
    label: "Selling mode",
    formatter: (value) => (value != null ? String(value) : "-")
  },
  {
    key: "id",
    label: "Product ID"
  }
];

export const exportCategoryColumns: ExportColumn<Category>[] = [
  {
    key: "name",
    label: "Category Name"
  },
  {
    key: "id",
    label: "Category ID"
  },
  {
    key: "parentId",
    label: "Parent Category",
    formatter: (value) => value ?? "Root Category"
  },
  {
    key: "description",
    label: "Description",
    formatter: (value) => value ?? "-"
  },
  {
    key: "status",
    label: "Status",
    formatter: (value) => stringFormatter(value as string)
  },
  {
    key: "createdAt",
    label: "Created Date",
    formatter: (value) => (value ? new Date(value).toLocaleDateString() : "-")
  },
  {
    key: "updatedAt",
    label: "Last Updated",
    formatter: (value) => (value ? new Date(value).toLocaleDateString() : "-")
  }
];
